import React from 'react';
import styles from '../layout/AdminLayout.module.css';

const UserQualificationComponent: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <div>
        <b className={styles.pageTitle}>회원 자격 관리</b>
      </div>
      
      <div className={styles.pageContent}>
        <p>회원 자격 관리 기능을 구현해주세요.</p>
      </div>
    </div>
  );
};

export default UserQualificationComponent;
